import React from 'react'

const ChevronDownIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <path d="M4.5 7.2981L9 11.7981L13.5 7.2981" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default ChevronDownIcon
